module.exports = __webpack_public_path__ + "media/images/general/icon_edit-4dc3367e68cd7c8202bf2d52da7431db.svg";